import React, { useRef, useState } from "react";
import { Button, Dropdown, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  openExchangeConnectionSettings,
  setSelectedPortfolioExchange,
} from "../../redux/exchange/actions";
import styles from "../../styles/Components/integration/ExchangesDropdown.module.css";
import useFetchIntegratedExchanges from "../../hooks/api/useFetchIntegratedExchanges";
import { FaAngleDown } from "react-icons/fa6";
import UpdateExchangeIpModal from "../../shared/exchange-ip-setting/UpdateExchangeIpModal";
import ExchangeConnectionSettingsMenu from "../../shared/connect-to-exchange/ExchangeConnectionSettingsMenu";
import { LazyLoadImage } from "react-lazy-load-image-component";

const IntegratedExchangesDropdown = ({
  className = "",
  title = "",
  btnStyle = {},
  controller = {},
}) => {
  const {
    exchangeState: {
      integratedData,
      integratedDataLoading,
      selectedPortfolioExchange,
      portfolioLoading,
      exchangeHistoryLoading,
      exchangeComprehensiveHistoryLoading,
      balanceChartStatus,
    },
    main: { userData },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  useFetchIntegratedExchanges();

  const [showIpSettingsModal, setShowIpSettingsModal] = useState(false);

  const username = userData?.["custom:custom_username"];
  const email = userData?.["cognito:username"];

  const selectedExchange = useRef(null);

  const realExchanges = integratedData?.filter(
    (ex) => ex?.id !== "cryptocrispy",
  );

  const selectedRealExchange =
    selectedPortfolioExchange !== "cryptocrispy" && selectedPortfolioExchange;

  const controllerRef = useRef(null);

  const abortPreviousRequests = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
  };

  const handleExchangeChange = (exchange) => {
    const { id, ip_status: ipStatus, status } = exchange;

    if (status !== "Active") {
      return dispatch(openExchangeConnectionSettings(id));
    }

    if (ipStatus !== "OK") {
      selectedExchange.current = exchange;
      return setShowIpSettingsModal(true);
    }

    if (
      portfolioLoading ||
      exchangeHistoryLoading ||
      exchangeComprehensiveHistoryLoading ||
      balanceChartStatus === "loading"
    ) {
      abortPreviousRequests();
    }

    if (controller) {
      controller.abort();
    }

    dispatch(setSelectedPortfolioExchange(id, username, email));
  };

  const renderIpStatusTag = (status) => {
    switch (status) {
      case "Need_Update":
        return <Tag color="orange">IP Update</Tag>;
      case "Expired":
        return <Tag color="orange">Expired</Tag>;
      default:
        return "";
    }
  };

  const menuItems = realExchanges.map((exchange) => {
    const { id, ip_status: ipStatus, status } = exchange;

    return {
      key: exchange.id,
      label: (
        <div
          className={`${styles.exchangeItem} ${selectedPortfolioExchange === id ? styles.selected : ""} `}
          style={
            status !== "Active" || ipStatus !== "OK" ? { opacity: 0.8 } : {}
          }
          onClick={() => handleExchangeChange(exchange)}
        >
          <div className={styles.exchange}>
            <LazyLoadImage
              src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${exchange.id}.svg`}
              alt={exchange.name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/placeholders/exchange-logo.svg";
              }}
              width="15px"
              height="15px"
              effect="blur"
              style={{ borderRadius: "100%" }}
            />
            <span>{exchange.name}</span>
          </div>
          {renderIpStatusTag(status) || renderIpStatusTag(ipStatus)}
        </div>
      ),
    };
  });

  return (
    <>
      <Dropdown
        menu={{ items: menuItems }}
        trigger={["click"]}
        rootClassName={styles.dropdown}
      >
        <Button
          className={className}
          loading={integratedDataLoading}
          style={btnStyle}
          onClick={(e) => {
            if (realExchanges?.length === 0) {
              e.stopPropagation();
              dispatch(openExchangeConnectionSettings());
            }
          }}
        >
          {selectedRealExchange || title || "Select Exchange"}
          {/*{selectedRealExchange && <span>{selectedRealExchange}</span>}*/}
          {/*<DownOutlined />*/}
          <FaAngleDown />
        </Button>
      </Dropdown>
      <UpdateExchangeIpModal
        show={showIpSettingsModal}
        setShow={setShowIpSettingsModal}
        exchangeData={selectedExchange}
      />
      <ExchangeConnectionSettingsMenu />
    </>
  );
};

export default IntegratedExchangesDropdown;
